/**
 * @generated SignedSource<<14e19e4779525d7f53a02cf394456134>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddDelegateModalMutation$variables = {
  expiry: string;
  userId: string;
};
export type AddDelegateModalMutation$data = {
  readonly createDelegate: {
    readonly delegate: {
      readonly createdAt: string | null;
      readonly delegate: {
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
      };
      readonly expiryDate: string | null;
      readonly id: string;
      readonly lastAccessed: string | null;
    } | null;
    readonly ok: boolean | null;
  } | null;
};
export type AddDelegateModalMutation = {
  response: AddDelegateModalMutation$data;
  variables: AddDelegateModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "expiry"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "expiry",
            "variableName": "expiry"
          },
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "CreateDelegatePayload",
    "kind": "LinkedField",
    "name": "createDelegate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Delegation",
        "kind": "LinkedField",
        "name": "delegate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expiryDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastAccessed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "delegate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "image",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddDelegateModalMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AddDelegateModalMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "08bfcbc26f40d12f4fd0a6e23271d195",
    "id": null,
    "metadata": {},
    "name": "AddDelegateModalMutation",
    "operationKind": "mutation",
    "text": "mutation AddDelegateModalMutation(\n  $userId: ID!\n  $expiry: DateTime!\n) {\n  createDelegate(input: {userId: $userId, expiry: $expiry}) {\n    ok\n    delegate {\n      id\n      expiryDate\n      lastAccessed\n      createdAt\n      delegate {\n        id\n        fullName\n        email\n        image\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8fc23f1ca9fc7ddc21a368571875a8e6";

export default node;
